import Chart from 'chartjs';
import moment from 'moment';
import i18n from 'l10n';
import ch from 'libs/chart-helpers';
import Handlebars from 'handlebars';

const it = {};

const queryOptions = {
    from: null, //long millis
    to: null, //long millis
    unit: "day",
    dow: null //first day of week (0-Sunday ...)
};

it.options = {
    from: null, //moment
    to: null, //moment
    window: null,
    queryOptions: queryOptions
};

it.options.from = moment().startOf('day').subtract(6, 'days');
it.options.to = moment().endOf('day');
const startOf = it.options.from.clone();
it.options.queryOptions.from = startOf.toDate().getTime();
const endOf = it.options.to.clone();
it.options.queryOptions.to = endOf.toDate().getTime();
const last7days = i18n.labels7ConsecutiveDays(moment());
const currentLocaleData = moment().localeData();

it.init = () => {

    it.options.queryOptions.dow = currentLocaleData.firstDayOfWeek();

    const handler3 = (json) => {

        json.creditsLastWeek.forEach((item, index) => {
            json.creditsLastWeek[index] = parseFloat(parseFloat(json.creditsLastWeek[index]).toFixed(2));
        });

        const smsCampaignsLastWeek = json.smsEmailCountriesToSmSContactsToEmailContactsLastWeek[0];
        const emailCampaignsLastWeek = json.smsEmailCountriesToSmSContactsToEmailContactsLastWeek[1];

        const reduceFunc = (a, b) => {
            return a + b;
        };

        const smsLastWeek = json.smsLastWeek.reduce(reduceFunc);
        const emailLastWeek = json.emailLastWeek.reduce(reduceFunc);

        const updateElements = (a, b) => {
            a.text(b);
            const cl = Handlebars.helpers.dynamicFontSize(b, a.data("font-length"));
            a.addClass(cl.toString());
        };

        const $smsCampaignLastWeek = $("#smsCampaignLastWeek");
        updateElements($smsCampaignLastWeek, smsCampaignsLastWeek);

        $("#smsCampaignsTitle").text(i18n.t("dashboard.campaigns", {count: smsCampaignsLastWeek}));

        const $emailCampaignLastWeek = $("#emailCampaignLastWeek");
        updateElements($emailCampaignLastWeek, emailCampaignsLastWeek);

        $("#emailCampaignsTitle").text(i18n.t("dashboard.campaigns", {count: emailCampaignsLastWeek}));

        const $smsSentLastWeek = $(".smsSentLastWeek");
        updateElements($smsSentLastWeek, smsLastWeek);

        const sumLastWeek = smsLastWeek + emailLastWeek;
        const pb = $("#smsEmailRatio").progressbar();
        pb.progressbar('value', (smsLastWeek / sumLastWeek * 100).toFixed(0));

        const $emailSentLastWeek = $(".emailSentLastWeek");
        updateElements($emailSentLastWeek, emailLastWeek);

        const getChartItem = (label, color, data) => {
            return {
                label: label,
                fillColor: ch.colors[color].transparent,
                strokeColor: ch.colors[color].solid,
                pointColor: ch.colors[color].solid,
                pointStrokeColor: '#fff',
                pointHighlightFill: '#fff',
                pointHighlightStroke: ch.colors[color].solid,
                data: data
            };
        };

        const produceDataSet = (isPostPaid, smsLastWeek, emailLastWeek, creditsLastWeek) => {
            if (isPostPaid === 1) {
                return [getChartItem(i18n.t('reports.smssent'), 'mauveUno', smsLastWeek),
                    getChartItem(i18n.t('reports.emailsent'), 'blueDue', emailLastWeek)];
            } else {
                return [getChartItem(i18n.t('reports.smssent'), 'mauveUno', smsLastWeek),
                    getChartItem(i18n.t('reports.emailsent'), 'blueDue', emailLastWeek),
                    getChartItem(i18n.t('dashboard.credits-spent'), 'greenTre', creditsLastWeek)];
            }
        };

        const isPostpaid = json.isPostpaid[0];
        const datasets = produceDataSet(isPostpaid, json.smsLastWeek, json.emailLastWeek, json.creditsLastWeek);

        const data = {
            labels: last7days,
            datasets: datasets
        };

        const options = {
            legendTemplate: "<%for (var i = 0; i < datasets.length; i++) { %>" +
                                "<span class=\"chartContentInfo\">" +
                                    "<span style=\"background-color: <%=datasets[i].strokeColor%>; " +
                                                  "width:15px; height: 10px; display: inline-block\">" +
                                    "</span>" +
                                    "<%if (datasets[i].label) {%> " +
                                        "<%=datasets[i].label%>" +
                                    "<%}%>" +
                                "</span>" +
                            "<%}%>" +
                            "<br/>" +
                            "<div style=\"align: center\">" +
                                "<a id=\"exportLink\" class=\"export-button\">" +
                                    "<span id=\"exportTitle\">" +
                                    "</span>" +
                                "</a>" +
                            "</div>",
            bezierCurve: false,
            datasetFill: false,
            responsive: true
        };

        const ctx = $("#smsEmailCreditsLineChart").get(0).getContext("2d");
        const myLineChart = new Chart(ctx).Line(data, options);
        const legend = myLineChart.generateLegend();

        $('#smsEmailCreditsLegend').html(legend).find('#exportLink').click(() => {
            const encodedUri = ch.exportHandler(myLineChart);
            $('#exportLink').attr({
                'href': encodedUri,
                'download': 'LastSevenDaysSmsEmail' + (isPostpaid ? 'Credits' : '') + 'Chart.txt',
                'id': 'exportLink'
            });
            $('#exportTitle').text(i18n.t("dashboard.export"));
        }).click();

    };

    $.ajaxDefaultQ({
        url: '/CampaignCloud/Report/LastWeekCreditsEmailSms',
        type: 'GET',
        contentType: 'application/json',
        dataType: 'json',
        success: handler3
    });

};

export default it;
